import './App.css';
import './i18n'; // Import i18n configuration
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home1 from './pages/home1';
import About from './pages/about';
import Home7 from './pages/home7_landscape';

import ContactPage from './pages/innerpages/contact';
import GalleryPage from './pages/innerpages/gallery';
import PortfolioPage from './pages/innerpages/portfolio';
import ProjectsPage from './pages/innerpages/project';
import FloorPage from './pages/innerpages/floor';
import ApartPage from './pages/innerpages/apart';
import TermsPage from './pages/innerpages/terms';

import SingleProject from './pages/innerpages/single_project';
import ApartmentDetails from './components/innerpage/apartament/ApartMap';

// Project pages
import BelleMare from './pages/projects/bellemare';
import Botanicheska302 from './pages/projects/botanicheska302';
import FifthElement from './pages/projects/fifthelement';
import Garden from './pages/projects/garden';
import M1 from './pages/projects/m1';
import M2 from './pages/projects/m2';
import ParadisePark from './pages/projects/paradisepark';
import PrestigePark from './pages/projects/prestigepark';
import Signature from './pages/projects/signature';
import TheFrame from './pages/projects/theframe';
import GrandParkLiving from './pages/projects/grandparkliving';


function App() {
  
  return (
     <><Helmet>
      <title>OneArt Construction – Строителна компания във Варна</title>
      <meta
        name="description"
        content="OneArt Construction е строителна компания с над 10 години опит във Варна. Специализираме в изграждането на жилищни сгради, търговски обекти и индустриални съоръжения с високо качество." />
    </Helmet><Router>
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/home1" element={<Home1 />} />
          <Route path="/about" element={<About />} />

          {/* //About us page */}
          <Route path="/home7_landscape" element={<Home7 />} />
          <Route path="/innerpages/contact" element={<ContactPage />} />
          <Route path="/innerpages/gallery" element={<GalleryPage />} />

          {/* Project page */}
          <Route path="/innerpages/portfolio" element={<PortfolioPage />} />
          <Route path="/innerpages/projects" element={<ProjectsPage />} />

          {/* Floors page */}
          <Route path='/innerpages/floor' element={<FloorPage />} />
          <Route path='/innerpages/apartamet-details' element={<ApartPage />} />
          <Route path="/apartments/:id" element={<ApartPage />} />
          <Route path="/innerpages/apartament-details" element={<ApartPage />} />


          {/* TermsPage */}
          <Route path="/innerpages/terms" element={<TermsPage />} />

          {/* Single apartament */}
          <Route path="/innerpages/single_project" element={<SingleProject />} />

          {/* Individual Project Pages */}
          <Route path="/projects/bellemare" element={<BelleMare />} />
          <Route path="/projects/botanicheska302" element={<Botanicheska302 />} />
          <Route path="/projects/fifthelement" element={<FifthElement />} />
          <Route path="/projects/garden" element={<Garden />} />
          <Route path="/projects/m1" element={<M1 />} />
          <Route path="/projects/m2" element={<M2 />} />
          <Route path="/projects/paradisepark" element={<ParadisePark />} />
          <Route path="/projects/prestigepark" element={<PrestigePark />} />
          <Route path="/projects/signature" element={<Signature />} />
          <Route path="/projects/theframe" element={<TheFrame />} />
          <Route path="/projects/grandparkliving" element={<GrandParkLiving />} />
        </Routes>
      </Router></>
  );
}

export default App;
